/**
 * Shared Forecast Summary mock data.
 *
 * Used by:
 *   - Financials tab → Forecast Performance section (read)
 *   - Forecast tab   → summary panel (read)
 *
 * In production these values come from the Forecast tab's committed state
 * (server-side snapshot or a shared React context seeded from the Forecast tab's
 * internal CostGroup / RevenueRow totals).  For now it is mock-only and
 * lives here so both tabs stay in sync.
 *
 * Set to `null` to simulate the "Forecast tab has no data yet" empty state.
 */

export interface ForecastSummaryMock {
  /** Total EAC cost across all cost rows in the Forecast tab (£) */
  totalForecastCost: number;
  /** Total forecast revenue across all revenue rows in the Forecast tab (£) */
  totalForecastRevenue: number;
  /** ISO date string of the last committed snapshot */
  lastSnapshotDate: string;
}

export const mockForecastSummary: ForecastSummaryMock | null = {
  totalForecastCost: 198_000,
  totalForecastRevenue: 265_000,
  lastSnapshotDate: '2026-08-31',
};
